import * as Sentry from "@sentry/react";

const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://c8fb6acdd850d4ac140521782ebbb6c4@o4512214405742592.ingest.de.sentry.io/4512214493823056";

function redact(value) {
  if (typeof value !== "string") return value;

  return value
    .replace(/(authorization|token|access_token|refresh_token|password|secret)=([^&\s]+)/gi, "$1=[Filtered]")
    .replace(/Bearer\s+[^\s]+/gi, "Bearer [Filtered]");
}

export function sanitizeSentryEvent(event) {
  const sanitizedEvent = { ...event };

  delete sanitizedEvent.user;
  delete sanitizedEvent.request;

  if (sanitizedEvent.breadcrumbs) {
    sanitizedEvent.breadcrumbs = sanitizedEvent.breadcrumbs.map((breadcrumb) => ({
      ...breadcrumb,
      message: redact(breadcrumb.message),
      data: undefined
    }));
  }

  if (sanitizedEvent.exception?.values) {
    sanitizedEvent.exception = {
      ...sanitizedEvent.exception,
      values: sanitizedEvent.exception.values.map((exception) => ({
        ...exception,
        value: redact(exception.value)
      }))
    };
  }

  if (sanitizedEvent.message) {
    sanitizedEvent.message = redact(sanitizedEvent.message);
  }

  return sanitizedEvent;
}

export function runSentryVerification() {
  if (
    process.env.REACT_APP_SENTRY_TEST_EVENT !== "true" ||
    typeof window === "undefined"
  ) {
    return false;
  }

  const query = new URLSearchParams(window.location.search);
  if (query.get("sentry-test") !== "1") return false;

  const cleanUrl = `${window.location.pathname}${window.location.hash}`;
  window.history.replaceState({}, document.title, cleanUrl);
  Sentry.captureMessage("Sentry browser verification event", "info");
  return true;
}

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  sendDefaultPii: false,
  tracesSampleRate: 0,
  beforeSend: sanitizeSentryEvent
});

export default Sentry;
